import { setUrlDefaults } from "@/routes/runtime"

type PageWithCompany = { props: { company_context?: { current: { id: number } } | null } }

const COMPANY_PATH = /^\/c\/(\d+)(?:\/|$)/
const COMPANY_PREFIX = /^\/c\/\d+/
const COMPANY_SECTION = /^\/c\/\d+(\/[^/?#]+)/

let pageCompanyId: number | undefined

/**
 * The company of a page that does not name one in its path (the companies page, the accountant's
 * client list): the one its props report. Called with every page the app shows.
 */
export function followPageCompany(page: PageWithCompany) {
  pageCompanyId = page.props.company_context?.current.id
}

/**
 * The company a link to a company's page names: the one in this
 * tab's path, which Inertia updates before it renders a page, else the page's. Each tab keeps its
 * own company, so a form opened in one company writes to it after another tab switched.
 */
export function linkCompanyId(pathname: string): number | string | undefined {
  return pathname.match(COMPANY_PATH)?.[1] ?? pageCompanyId
}

/** A link to a company's page (from a route helper), for another company of the account. */
export function inCompany(url: string, companyId: number): string {
  return url.replace(COMPANY_PREFIX, `/c/${companyId}`)
}

/**
 * The page a switch to another company opens: the same section ("/c/9/documents" from
 * "/c/4/documents/12/edit"), since a record belongs to its own company; the transactions from a
 * page of no company.
 */
export function companySwitchPath(pathname: string, companyId: number): string {
  const section = pathname.match(COMPANY_SECTION)?.[1] ?? "/payments"
  return `/c/${companyId}${section}`
}

/** The defaults of the route helpers on a page at `pathname`, in the helpers' own camelCase. */
export function companyUrlDefaults(pathname: string): Record<string, unknown> {
  const companyId = linkCompanyId(pathname)
  return companyId == null ? {} : { companyId }
}

setUrlDefaults(() => companyUrlDefaults(window.location.pathname))
